import { render } from "./App.vue?vue&type=template&id=5e30a79e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5e30a79e&lang=scss"

import exportComponent from "C:\\Users\\haqua\\Documents\\vue\\rebrand\\feedback-page-resell\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__